(function () {
  // VARIANT_MAP: keyed by the buy-box radio input's `value` attribute (553 /
  // 555 / 556 on the source page). Built from a fresh product query against
  // this store -- see build notes -- NOT copied from another product's page.
  //   Buy 1            -> $29.99 (compare $39.99) -> variant 45790016340077
  //   Buy 2 Get 1 Free -> $59.99 (compare $89.99) -> variant 45790016372845 (default/checked)
  //   Buy 3 Get 2 Free -> $89.99 (compare $129.99) -> variant 45790016405613
  // All three prices were cross-checked against what this live source page
  // actually displays for each tier and match exactly.
  var VARIANT_MAP = {
    '553': 45790016340077,
    '555': 45790016372845,
    '556': 45790016405613
  };

  // Shipping-protection add-on (Priority Insured Shipping, $4.95) -- added
  // to every order alongside whatever tier the visitor selects, regardless
  // of quantity/tier, same as every other CC-clone product on this store.
  var SHIPPING_PROTECTION_VARIANT_ID = 42265412305005;

  // Any tier's variant can be switched to subscription-only
  // (requiresSellingPlan: true) independently of the others, and it has
  // been -- first just Buy 1, then all three tiers ended up requiring a
  // plan on the same day (2026-08-31). Submitting a required-selling-plan
  // variant with no selling_plan fails Shopify's cart validation with a
  // 422 "Cart Error: Variant can only be purchased with a selling plan,"
  // which renders as Shopify's own generic full-page error.
  //
  // This used to be a hardcoded { variantId: sellingPlanId } map, but the
  // plan ID itself is NOT stable: it belongs to whichever subscription
  // app currently manages the product, and swapping apps (Subscribe &
  // Save -> Loop, 2026-08-31) deletes the old plan/group entirely and has
  // the new app provision a brand new ID -- for the SAME variant. That
  // broke Buy 1 twice in one day, and by the time it was fixed the same
  // reconfiguration had already been applied to Buy 2 Get 1 and Buy 3 Get
  // 2 too, each landing on yet another new plan ID. Hardcoding three IDs
  // now just means hand-patching this file the next time any tier's
  // required plan changes, on this product and every other CC-clone
  // product this same pattern gets applied to.
  //
  // Instead: look up whether the SELECTED variant currently requires a
  // selling plan, and which plan ID to use, live from Shopify's own
  // public product AJAX endpoint (/products/{handle}.js) at the moment of
  // an actual click -- never assume it's still whatever it was on the last
  // deploy. Keyed by variant ID -> product handle (handles are stable;
  // plan IDs aren't). Cached in-memory per page load so re-clicking the
  // same tier doesn't refetch.
  var PRODUCT_HANDLE_MAP = {
    '45790016340077': 'kavera-nattokinase-buy-1',
    '45790016372845': 'kavera-nattokinase-buy-2-get-1-free',
    '45790016405613': 'kavera-nattokinase-buy-3-get-2-free'
  };
  var sellingPlanCache = {};
  function getRequiredSellingPlan(variantId) {
    if (Object.prototype.hasOwnProperty.call(sellingPlanCache, variantId)) {
      return Promise.resolve(sellingPlanCache[variantId]);
    }
    var handle = PRODUCT_HANDLE_MAP[variantId];
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var variant = (product.variants || []).filter(function (v) { return v.id === variantId; })[0];
        var planId = null;
        if (variant && variant.requires_selling_plan && product.selling_plan_groups && product.selling_plan_groups.length) {
          var plan = product.selling_plan_groups[0].selling_plans && product.selling_plan_groups[0].selling_plans[0];
          if (plan) planId = plan.id;
        }
        sellingPlanCache[variantId] = planId;
        return planId;
      })
      .catch(function () { return null; });
  }

  function getCheckedRadio() {
    return document.querySelector('input[name="product"]:checked');
  }

  // The visible buy-box card (.product-selector_block) is a <div> nested
  // inside a <label for="ps-opt-N">, not the label itself and not a DOM
  // ancestor/descendant of the radio input -- it's wired purely via the
  // label's for/id relationship. Look it up that way to sync the .active
  // class (bubble color, border) whenever the selection changes.
  function syncActiveStyling() {
    document.querySelectorAll('input[name="product"]').forEach(function (radio) {
      var label = document.querySelector('label[for="' + radio.id + '"]');
      var block = label ? label.querySelector('.product-selector_block') : null;
      if (!block) return;
      block.classList.toggle('active', radio.checked);
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input[name="product"]')) {
      syncActiveStyling();
    }
  });

  function setAtcLoading(btn, loading) {
    if (!btn) return;
    btn.style.pointerEvents = loading ? 'none' : '';
    btn.style.opacity = loading ? '0.6' : '';
    btn.dataset.originalText = btn.dataset.originalText || btn.textContent;
    btn.textContent = loading ? 'Adding...' : btn.dataset.originalText;
  }

  // bfcache stuck-button fix: a customer hitting the browser Back button from
  // /checkout gets this page restored exactly as it was the instant they left
  // (bfcache), including the ATC button's inline disabled/"Adding..." state if
  // it was mid-submit. Reset it on every bfcache restore.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.product-selector_atc').forEach(function (btn) {
      setAtcLoading(btn, false);
    });
  });

  // Retries a fetch once/twice with a backoff on a 429 (rate limited) or
  // 5xx response, or a network-level failure -- a safety net for the rarer
  // clear+add (tier-switch) path below, not a substitute for avoiding
  // redundant calls in the first place (see addToCartAndCheckout).
  function fetchWithRetry(url, options, retries, delayMs) {
    return fetch(url, options).then(function (res) {
      if (!res.ok && (res.status === 429 || res.status >= 500) && retries > 0) {
        return new Promise(function (resolve) { setTimeout(resolve, delayMs); })
          .then(function () { return fetchWithRetry(url, options, retries - 1, delayMs * 2); });
      }
      return res;
    }, function (err) {
      if (retries > 0) {
        return new Promise(function (resolve) { setTimeout(resolve, delayMs); })
          .then(function () { return fetchWithRetry(url, options, retries - 1, delayMs * 2); });
      }
      throw err;
    });
  }

  // Reads the REAL current cart from Shopify (not a client-side flag) so
  // the fresh-add / repeat-click / tier-switch decision below is always
  // based on what's actually in the cart, not on what we think we added
  // last time.
  //
  // 2026-08-31 incident: this used to be a localStorage flag
  // ("acromActiveCartVariant") set BEFORE the native form-post's outcome
  // was known. Any add that failed server-side (e.g. a 422 from a missing
  // or stale selling_plan -- see getRequiredSellingPlan above, which has
  // needed a new plan ID three times in one day already) still left the
  // flag saying "already added." The
  // next click then trusted that stale flag, skipped straight to
  // `window.location.href = '/checkout'` with an EMPTY real cart, and
  // Shopify silently redirects an empty-cart checkout to the store's home
  // page -- which is exactly what "ATC redirects to the home page" turned
  // out to be, and it kept recurring on every fix because the flag, once
  // poisoned by one failed click, never got fixed by fixing the code that
  // caused the failure.
  //
  // A GET to /cart.js is safe to make on every click: the bot-detection
  // issue the 2026-08-28 EMERGENCY FIX below exists to avoid is
  // specifically about repeated cart-WRITE calls (/cart/add.js,
  // /cart/clear.js), not reads.
  function getCartState() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (res) { return res.json(); });
  }

  // EMERGENCY FIX (2026-08-28): this page sells mutually-exclusive bundle
  // tiers as separate variants, not add-on quantities -- clearing before
  // adding prevents the cart from ever holding more than one tier's line
  // item at once. The previous version unconditionally called clear.js
  // THEN add.js on every single click -- two Shopify AJAX Cart API calls
  // per click, even on a customer's first, completely normal click, with
  // no retry on failure. Confirmed live in production: Shopify's cart
  // endpoints apply bot-detection that can 429 after as few as 2-3 calls
  // in a short window (documented regression --
  // community.shopify.dev/t/aggressive-bot-detection-with-429-errors-ajax-cart-api),
  // and the doubled call volume here made that far more likely to trip on
  // real customers, surfacing as a broken, unrecoverable ADD TO CART
  // button. Fixed to match a standard Shopify ATC button: a fresh click
  // this session makes exactly ONE cart call (add). Clicking the SAME
  // tier again makes ZERO calls (already in cart, straight to checkout).
  // Only an actual tier SWITCH makes two calls (clear, then add) -- the one
  // case that genuinely needs it. Every remaining call also retries once
  // or twice with a backoff on a 429/5xx so a transient rate-limit blip
  // never reaches the customer as a broken button.
  // Submits a REAL, native <form method="post" action="/cart/add"> --
  // a genuine full-page browser navigation, not a fetch()/XHR AJAX call.
  // Shopify's bot-detection issue documented above is specifically an
  // "AJAX Cart API" problem (fetch calls to the .js-suffixed endpoints);
  // a classic form POST to the non-.js /cart/add endpoint is the same
  // mechanism every plain Shopify "Buy Now" button has used for years and
  // is not the pattern that detection watches for. The return_to field is
  // a native Shopify feature: it redirects straight to /checkout after a
  // successful add, with no custom JS involved in that step at all.
  function submitAddToCartForm(variantId, sellingPlanId) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.style.display = 'none';
    var fields = [['id', variantId], ['quantity', 1], ['items[1][id]', SHIPPING_PROTECTION_VARIANT_ID], ['items[1][quantity]', 1], ['return_to', '/checkout']];
    if (sellingPlanId) fields.push(['selling_plan', sellingPlanId]);
    fields.forEach(function (pair) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = pair[0];
      input.value = pair[1];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function addToCartAndCheckout(e) {
    e.preventDefault();
    var btn = e.currentTarget;
    var checked = getCheckedRadio();
    var variantId = checked ? VARIANT_MAP[checked.value] : null;
    if (!variantId) {
      alert('Please select an offer above.');
      return;
    }
    setAtcLoading(btn, true);
    // Cart-read and selling-plan lookup are independent -- run them in
    // parallel rather than chaining, so a required-selling-plan tier isn't
    // any slower to click than a plain one-time-purchase tier.
    Promise.all([getCartState(), getRequiredSellingPlan(variantId)]).then(function (results) {
      var cart = results[0];
      var sellingPlanId = results[1];
      var items = cart.items || [];
      var hasThisVariant = items.some(function (item) { return item.id === variantId; });
      if (hasThisVariant) {
        // Already in the (real, server-confirmed) cart -- zero AJAX
        // cart-write calls, straight to checkout.
        window.location.href = '/checkout';
        return;
      }
      var hasOtherTier = items.some(function (item) {
        return item.id !== variantId && item.id !== SHIPPING_PROTECTION_VARIANT_ID;
      });
      if (!hasOtherTier) {
        // Common case (nothing else of ours in the cart): zero AJAX
        // cart-write calls -- straight to the native form-post add+redirect.
        submitAddToCartForm(variantId, sellingPlanId);
        return;
      }
      // Tier switch (rare): one AJAX call to clear the previous tier, then
      // the same native form-post add+redirect for the new one -- still
      // avoids ever chaining two AJAX cart-write calls back to back.
      fetchWithRetry('/cart/clear.js', { method: 'POST' }, 2, 1000)
        .then(function () {
          submitAddToCartForm(variantId, sellingPlanId);
        })
        .catch(function () {
          setAtcLoading(btn, false);
          alert('Could not update your cart. Please try again.');
        });
    }).catch(function () {
      // Couldn't even read the cart/selling-plan state -- fail safe with a
      // fresh, no-selling-plan add rather than getting stuck (worst case:
      // an unnecessary but harmless duplicate-tier line item, or a 422 if
      // the tier genuinely needed a plan -- never a silent no-op).
      submitAddToCartForm(variantId, null);
    });
  }

  // Generic accordion: clicking thumbSelector toggles .active on the closest
  // blockSelector ancestor and shows/hides its contentSelector child. Each
  // item opens/closes independently. Covers the ingredients/how-it-works/
  // shipping tab panel (.product_tab-*) and the "Inside Each Bottle" blocks
  // (.product-inside_block*) -- neither ships its own inline script on the
  // source page, only CSS support for the .active state.
  function wireAccordion(thumbSelector, blockSelector, contentSelector) {
    document.querySelectorAll(thumbSelector).forEach(function (thumb) {
      thumb.style.cursor = 'pointer';
      thumb.addEventListener('click', function () {
        var block = thumb.closest(blockSelector);
        if (!block) return;
        var content = block.querySelector(contentSelector);
        var opening = !block.classList.contains('active');
        block.classList.toggle('active', opening);
        if (content) content.style.display = opening ? 'block' : 'none';
      });
    });
  }

  // FAQ accordion: single-open (closes every other FAQ box before opening the
  // clicked one), matching the source page's own behavior for this block.
  // The theme's base CSS only styles the chevron rotation off .active -- it
  // has no rule that actually shows/hides .product_faq-content (confirmed
  // live: .active toggled correctly but the content stayed display:none), so
  // the show/hide has to be driven directly here rather than left to CSS.
  function wireFaqAccordion() {
    function setBoxOpen(box, opening) {
      box.classList.toggle('active', opening);
      var content = box.querySelector('.product_faq-content');
      if (content) content.style.display = opening ? 'block' : 'none';
    }
    document.querySelectorAll('.product_faq-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var box = thumb.closest('.product_faq-box');
        if (!box) return;
        var wasActive = box.classList.contains('active');
        document.querySelectorAll('.product_faq-box').forEach(function (b) {
          setBoxOpen(b, false);
        });
        if (!wasActive) setBoxOpen(box, true);
      });
    });
  }

  // "Try Try KAVERA Nattokinase Risk-Free" CTA buttons (.product_primary-btn.scrolling,
  // href="javascript:void(0)") -- on the source page these smooth-scroll up
  // to the buy box. Reimplemented generically since the click was originally
  // handled by CheckoutChamp's own stripped engine.
  function wireScrollingButtons() {
    document.querySelectorAll('.product_primary-btn.scrolling').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector('.product_selector-content') || document.querySelector('.main_product-outer');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // Tiffany review-photo lightbox: click the small round photo thumbnail to
  // open a full-size lightbox view; close via the X, clicking the dark
  // backdrop, or Escape. Ported from the source page's own inline script
  // (verbatim behavior), just written generically instead of hardcoded to a
  // single "-tiffany" id suffix in case more than one photo/lightbox pair
  // exists on a future page reusing this same template.
  function wirePhotoLightboxes() {
    document.querySelectorAll('.acrom-photo__thumb').forEach(function (thumb) {
      var wrapper = thumb.closest('.acrom-photo');
      if (!wrapper) return;
      var box = wrapper.querySelector('.acrom-lb') || document.getElementById(thumb.id.replace('acrom-photo-thumb-', 'acrom-lb-'));
      if (!box) return;
      var img = box.querySelector('.acrom-lb__img');
      var stage = box.querySelector('.acrom-lb__stage');
      var close = box.querySelector('.acrom-lb__close');
      if (!img || !stage || !close) return;

      function openLb() {
        img.src = thumb.getAttribute('data-acrom-full');
        box.classList.add('is-open');
        box.setAttribute('aria-hidden', 'false');
        document.body.classList.add('acrom-lb-open');
      }
      function closeLb() {
        box.classList.remove('is-open');
        box.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('acrom-lb-open');
        img.src = '';
      }
      thumb.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openLb(); });
      thumb.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(); } });
      close.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeLb(); });
      close.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); closeLb(); } });
      stage.addEventListener('click', function (e) { if (e.target === stage) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('is-open')) closeLb(); });
    });
  }

  // UGC video cards: no native <video controls>, and no default play/pause
  // behavior without JS (the source page's own click-to-play logic lived in
  // CheckoutChamp's stripped engine). Clicking the play-button overlay (or
  // the video itself) toggles playback and hides/shows the overlay + poster.
  function wireUgcVideos() {
    document.querySelectorAll('.product_ugc-video').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var playBtn = wrap.querySelector('.product_ugc-play');
      if (!video) return;
      function togglePlay() {
        if (video.paused) {
          video.play();
          if (playBtn) playBtn.style.display = 'none';
        } else {
          video.pause();
          if (playBtn) playBtn.style.display = '';
        }
      }
      if (playBtn) playBtn.addEventListener('click', togglePlay);
      video.addEventListener('click', togglePlay);
      video.addEventListener('ended', function () { if (playBtn) playBtn.style.display = ''; });
    });
  }

  // Mobile hero image slider (.cs-wrapper / .cs-viewport / .cs-track /
  // .cs-thumbs / .cs-dots): native CSS scroll-snap does the actual swiping,
  // this keeps the dot/thumbnail strip in sync with the visible slide and
  // wires taps on either to scroll to that slide. Ported near-verbatim from
  // the source page's own "custom-slider-fix-js" inline script (it already
  // shipped complete, working vanilla JS for this -- no CheckoutChamp engine
  // dependency -- so it's reused as-is rather than rebuilt).
  function initCustomSlider() {
    var viewport = document.getElementById('csViewport');
    var track = document.getElementById('csTrack');
    var dotsContainer = document.getElementById('csDots');
    var thumbsContainer = document.getElementById('csThumbs');
    var prevBtn = document.getElementById('csPrev');
    var nextBtn = document.getElementById('csNext');

    if (!viewport || !track) return;

    var slides = viewport.querySelectorAll('.cs-slide');
    var total = slides.length;
    if (total === 0) return;
    var current = 0;
    var scrollTimeout = null;

    function scrollThumbIntoView(idx) {
      if (!thumbsContainer) return;
      var thumbs = thumbsContainer.querySelectorAll('.cs-thumb');
      var thumb = thumbs[idx];
      if (!thumb) return;
      var containerWidth = thumbsContainer.clientWidth;
      var thumbLeft = thumb.offsetLeft;
      var thumbWidth = thumb.offsetWidth;
      var thumbRight = thumbLeft + thumbWidth;
      var currentScroll = thumbsContainer.scrollLeft;
      var targetScroll = currentScroll;
      if (thumbRight > currentScroll + containerWidth) {
        targetScroll = thumbRight - containerWidth;
      } else if (thumbLeft < currentScroll) {
        targetScroll = thumbLeft;
      }
      if (targetScroll !== currentScroll) {
        thumbsContainer.scrollTo({ left: targetScroll, behavior: 'smooth' });
      }
    }

    function updateUI(idx) {
      if (idx === current) return;
      current = idx;
      var dots = dotsContainer ? dotsContainer.querySelectorAll('.cs-dot') : [];
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('cs-dot-active', i === current);
      if (thumbsContainer) {
        var thumbs = thumbsContainer.querySelectorAll('.cs-thumb');
        for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.toggle('cs-thumb-active', j === current);
      }
      scrollThumbIntoView(current);
    }

    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx >= total) idx = total - 1;
      current = idx;
      var dots = dotsContainer ? dotsContainer.querySelectorAll('.cs-dot') : [];
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('cs-dot-active', i === current);
      if (thumbsContainer) {
        var thumbs = thumbsContainer.querySelectorAll('.cs-thumb');
        for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.toggle('cs-thumb-active', j === current);
      }
      scrollThumbIntoView(current);
      var slideWidth = slides[0] ? slides[0].offsetWidth : viewport.offsetWidth;
      viewport.scrollTo({ left: idx * slideWidth, behavior: 'smooth' });
    }

    function detectCurrentSlide() {
      var slideWidth = slides[0] ? slides[0].offsetWidth : viewport.offsetWidth;
      if (slideWidth === 0) return;
      var newIdx = Math.round(viewport.scrollLeft / slideWidth);
      if (newIdx < 0) newIdx = 0;
      if (newIdx >= total) newIdx = total - 1;
      if (newIdx !== current) updateUI(newIdx);
    }

    viewport.addEventListener('scroll', function () {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(detectCurrentSlide, 50);
    }, { passive: true });

    if (thumbsContainer) {
      var thumbItems = thumbsContainer.querySelectorAll('.cs-thumb');
      for (var i = 0; i < thumbItems.length; i++) {
        thumbItems[i].addEventListener('click', function (e) { e.preventDefault(); goTo(+this.dataset.idx); });
      }
    }
    var dotItems = dotsContainer ? dotsContainer.querySelectorAll('.cs-dot') : [];
    for (var d = 0; d < dotItems.length; d++) {
      dotItems[d].addEventListener('click', function (e) { e.preventDefault(); goTo(+this.dataset.idx); });
    }
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); goTo(current - 1 < 0 ? total - 1 : current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); goTo(current + 1 >= total ? 0 : current + 1); });

    window.addEventListener('resize', function () {
      var slideWidth = slides[0] ? slides[0].offsetWidth : viewport.offsetWidth;
      viewport.scrollLeft = current * slideWidth;
      scrollThumbIntoView(current);
    });

    viewport.scrollLeft = 0;
  }

  // Slick review/UGC carousels: the static markup was already unwrapped back
  // to plain, un-initialized slides at build time (no leftover
  // slick-initialized/slick-track/slick-list artifacts), so a normal init is
  // safe here -- no double-init reset dance needed. Options read LIVE off the
  // real source page via jQuery('.selector').slick('getSlick').options rather
  // than the page's own (superseded/dead) static inline init script, which
  // specifies different values than what's actually in effect at runtime.
  function initCarousels() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(initCarousels, 200);
      return;
    }
    var $ = jQuery;

    var reviewOpts = {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: false,
      adaptiveHeight: false,
      swipe: true,
      touchMove: true,
      touchThreshold: 5,
      speed: 500,
      cssEase: 'ease',
      responsive: [{ breakpoint: 677, settings: { slidesToShow: 1.7, slidesToScroll: 1 } }]
    };
    var ugcOpts = {
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: false,
      adaptiveHeight: false,
      swipe: true,
      touchMove: true,
      touchThreshold: 5,
      speed: 500,
      cssEase: 'ease',
      responsive: [{ breakpoint: 677, settings: { slidesToShow: 1.3, slidesToScroll: 1 } }]
    };

    $('.product_review-container').each(function () {
      if (!$(this).hasClass('slick-initialized')) $(this).slick(reviewOpts);
    });
    $('.product_ugc-container').each(function () {
      if (!$(this).hasClass('slick-initialized')) $(this).slick(ugcOpts);
    });

    $('.product_ugc-carousel-nav').each(function () {
      var $nav = $(this);
      var $carousel = $nav.closest('.product_carousel-outer').find('.product_review-container, .product_ugc-container');
      if ($carousel.length && $carousel.hasClass('slick-initialized')) {
        $nav.find('.product_carousel-prev').on('click', function () { $carousel.slick('slickPrev'); });
        $nav.find('.product_carousel-next').on('click', function () { $carousel.slick('slickNext'); });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncActiveStyling();
    document.querySelectorAll('.product-selector_atc').forEach(function (btn) {
      btn.addEventListener('click', addToCartAndCheckout);
    });
    wireFaqAccordion();
    wireAccordion('.product_tab-thumb', '.product_tab-block', '.product_tab-content');
    wireAccordion('.product-inside_block-thumb', '.product-inside_block', '.product-inside_block-content');
    wireScrollingButtons();
    wirePhotoLightboxes();
    wireUgcVideos();
    initCustomSlider();
    setTimeout(initCarousels, 500);
  });
})();
